import { useRecoilValue, useSetRecoilState } from "recoil";
import { checkListState } from "../../../recoil/report/checkListState";
import { useQueries } from "@tanstack/react-query";
import { usePatient } from "../../../context/PatientContext";
import {
  endDateWithTimeSelector,
  startDateWithTimeSelector,
} from "../../../recoil/report/dateRangeState";
import { checkListRaw } from "../../../constant";
import { reportDataState } from "../../../recoil/report/reportDataState";
import { useEffect } from "react";
import { reportFilterState } from "../../../recoil/report/reportFilterState";

const Step3 = ({ print = false }) => {
  const { patient } = usePatient();
  const checkList = useRecoilValue(checkListState);
  const startDate = useRecoilValue(startDateWithTimeSelector);
  const endDate = useRecoilValue(endDateWithTimeSelector);
  const filters = useRecoilValue(reportFilterState);

  // Flatten the grouped items to get all labels
  const labels = Object.values(checkList).flat();

  const fetchLabelData = async (label) => {
    debugger
    const config = checkListRaw.find((item) => item.label === label);
    if (!config?.api) return { res: null, label };

    const api = config.api;

    // Filters configured for this label in constant.js
    const filtersConfig = config.filters || []; // e.g. [{ field: "isImp" }, { field: "types" }]
    const labelFilterValues = filters[label] || {}; // from Step1 (reportFilterState)

    // Pick only fields defined in constant.js
    const filterPayload = filtersConfig.reduce((acc, f) => {
      if (labelFilterValues[f.field] !== undefined) {
        acc[f.field] = labelFilterValues[f.field];
      }
      return acc;
    }, {});

    // 🔗 Pass filters to the API (4th arg here – adjust to your function signature)
    const res = await api(patient?.id, startDate, endDate, filterPayload);

    return { res, label, filters: filterPayload };
  };

  const setReportData = useSetRecoilState(reportDataState);
  const queryResults = useQueries({
    queries: labels?.map((label) => ({
      queryKey: [label, "Report", patient?.id, filters[label] || {}],
      queryFn: () => fetchLabelData(label),
      enabled: !!patient?.id,
      refetchOnWindowFocus: false,
    })),
  });

  const handleSetReport = () => {
    try {
      if (queryResults.every((result) => result.status === "success")) {
        const reportData = queryResults.map((result) => result);
        setReportData(reportData);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (queryResults.every((result) => result.status === "success")) {
      handleSetReport();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryResults]);
  return (
    <>
      {queryResults.map((result, index) => {
        const label = labels[index];
        if (result.isFetching) return <div key={index}>Loading {label}...</div>;
        if (result.isError) return <div key={index}>Error loading {label}</div>;
        const Component = checkListRaw.find(
          (item) => item.label === (result.data.label || label)
        ).component;
        if (!!result?.data?.res) {
          return <Component key={index} data={result.data} className="flex" print={print} />;
        }
        return null;
      })}
    </>
  );
};

export default Step3;
